import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import "./Assets/Fonts/Cairo/Cairo-Regular.ttf";
import "./Assets/Fonts/Cairo/Cairo-Black.ttf";
import "./Assets/Fonts/Cairo/Cairo-Bold.ttf";
import "./Assets/Fonts/Cairo/Cairo-ExtraLight.ttf";
import "./Assets/Fonts/Cairo/Cairo-SemiBold.ttf";
import "./Assets/Fonts/Cairo/Cairo-Light.ttf";
import "./Assets/Fonts/Sans/KumbhSans-Black.ttf";
import "./Assets/Fonts/Sans/KumbhSans-Bold.ttf";
import "./Assets/Fonts/Sans/KumbhSans-ExtraBold.ttf";
import "./Assets/Fonts/Sans/KumbhSans-ExtraLight.ttf";
import "./Assets/Fonts/Sans/KumbhSans-Light.ttf";
import "./Assets/Fonts/Sans/KumbhSans-Medium.ttf";
import "./Assets/Fonts/Sans/KumbhSans-Regular.ttf";
import "./Assets/Fonts/Sans/KumbhSans-SemiBold.ttf";
import "./Assets/Fonts/Sans/KumbhSans-Thin.ttf";
import "react-toastify/dist/ReactToastify.css";
import "react-international-phone/style.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
    <ToastContainer />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
